export class VehicleConfigurationView {
    public vehicleTypeCode: string;
    public vehicleCompositionId: string;
    public vehicleId: string;
}